import React from 'react';
import PropTypes from 'prop-types';

import Column from '../Column';
import Grid from '../Grid';

import SC from './styles.js';

const Footer = props => {
  const { footer, links, socialLinks, copyrightText, baseUrl } = props;

  const calculatedHrefUrl = link => {
    if (link && (link.startsWith('http://') || link.startsWith('https://'))) {
      return link;
    }
    if (baseUrl) {
      return baseUrl + link;
    }
    return link;
  };

  return (
    <Grid>
      {footer && (
        <SC.FooterPagesRow>
          {footer.items.map((item, key) => {
            return (
              <Column key={key}>
                <SC.HeadingAnchor href={item.heading.src}>
                  {item.heading.title}
                </SC.HeadingAnchor>
                {item.children.map((child, key) => {
                  return (
                    <SC.FooterPage sm={12} key={key}>
                      <SC.FooterPageAnchor href={child.src}>
                        {child.title}
                      </SC.FooterPageAnchor>
                    </SC.FooterPage>
                  );
                })}
              </Column>
            );
          })}
        </SC.FooterPagesRow>
      )}
      <SC.FooterLinksRow>
        {links && (
          <Column sm={12}>
            <SC.Divider />
            <SC.FlexGrid>
              <SC.Navigation>
                {links.map((item, key) => {
                  return (
                    <SC.Anchor key={key} href={calculatedHrefUrl(item.link)}>
                      {item.text}
                    </SC.Anchor>
                  );
                })}
              </SC.Navigation>
              <SC.Copyright>{copyrightText}</SC.Copyright>
            </SC.FlexGrid>
          </Column>
        )}
        {socialLinks && (
          <Column sm={12}>
            <SC.Social>
              {socialLinks.map((item, key) => {
                return (
                  <SC.SocialLink key={key} href={item.link} target="_blank">
                    <SC.SocialIcon src={item.icon} alt={item.text} />
                  </SC.SocialLink>
                );
              })}
            </SC.Social>
          </Column>
        )}
      </SC.FooterLinksRow>
    </Grid>
  );
};

Footer.propTypes = {
  /** Array of links for footer navigation */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string
    })
  ),
  /** Array of pages for footer links above footer navigation */
  footer: PropTypes.shape({
    heading: PropTypes.shape({
      title: PropTypes.string,
      src: PropTypes.string
    }),
    children: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        src: PropTypes.string
      })
    )
  }),
  /** Copyright Text */
  copyrightText: PropTypes.string,
  /** Social Media links */
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
      icon: PropTypes.string
    })
  ),
  /** Base url for absolute paths */
  baseUrl: PropTypes.string
};

Footer.legacyName = ['ux-footer-links', 'ux-footer-singtel'];
export default Footer;
